var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.5C0.5 5.2533 4.7533 1 10 1C15.2467 1 19.5 5.2533 19.5 10.5C19.5 15.7467 15.2467 20 10 20C4.7533 20 0.5 15.7467 0.5 10.5Z",
    stroke: "#5E66BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92926 14.1L5.80078 10.9715L6.5829 10.1894L8.92926 12.5358L13.965 7.5L14.7471 8.28212L8.92926 14.1Z",
    fill: "#5E66BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckNew);
export default __webpack_public_path__ + "static/media/checkNew.bfa99b37dc9d06bbf81f0e8c8e9340f6.svg";
export { ForwardRef as ReactComponent };